import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';

// Import pages
import HomePage from './pages/HomePage';
import SalesPitchPage from './pages/SalesPitchPage';
import BookingPage from './pages/BookingPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sales-pitch-onsite-call-from-ai" element={<SalesPitchPage />} />
          <Route path="/book-call" element={<BookingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
